<ion-segment *ngIf="items.length > 0" [ngClass]="class" [attr.scrollable]="config.scroll ? 'scrollable' : null">
  <div *ngFor="let item of items" >
      <ion-segment-button (click)="gatemanService.routeHub(item.link)">

        <ion-thumbnail>
          <img [src]="item.icon" [alt]="item.title | multiLang" loading="lazy"/>
          <!-- <ion-img [src]="item.icon" [alt]=""></ion-img> -->
        </ion-thumbnail>
   </ion-segment-button>
  </div>
</ion-segment>